import React from "react";

import { useTranslation } from "react-i18next";

import m1 from '../../img/AboutUs/m1.webp';
import m2 from '../../img/AboutUs/m2.webp';

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

function Mission () {

    const { t } = useTranslation();

    const controls = useAnimation();
    const [ref, inView] = useInView({ triggerOnce: true }); // `triggerOnce` - чтобы не повторялась

    useEffect(() => {
    if (inView) {
        controls.start({
        opacity: 1,
        clipPath: "inset(0% 0% 0% 0%)",
        transition: { duration: 1, ease: "easeOut" }
        });
    }
    }, [inView, controls]);
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex flex-col xl:flex-row justify-between items-center">
                    <div className="w-full xl:w-[728px] xl:h-[249px] xl:bg-[#272727] flex flex-col justify-center xl:px-[35px]">
                        <p className="text-[#F26522] open-sans xl:text-[45px] text-[28px]">{t('about.7')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] xl:max-w-[460px] text-[#F6F6F6]">{t('about.8')}</p>
                    </div>
                    <div className="mt-[20px] xl:mt-0">
                        <p className="text-[#F26522] open-sans xl:text-[20px] text-[16px]">{t('about.9')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] xl:max-w-[382px] text-[#F6F6F6]">{t('about.10')}</p>
                    </div>
                </div>
                <div className="flex flex-col xl:flex-row-reverse justify-between items-center mt-[35px] xl:mt-[50px]">
                    <motion.div
                        ref={ref}
                        initial={{ opacity: 0, clipPath: "inset(0% 50% 0% 50%)" }}
                        animate={controls}
                        className="w-full xl:w-auto"
                    >
                        <img src={m1} alt="" className="h-[115px] md:h-[249px] w-full object-cover xl:w-auto"/>
                    </motion.div>
                    <div className="mt-[20px] xl:mt-0">
                        <p className="text-[#F26522] open-sans xl:text-[20px] text-[16px]">{t('about.11')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] xl:max-w-[382px] text-[#F6F6F6]">{t('about.12')}</p>
                    </div>
                </div>
                <div className="flex flex-col xl:flex-row justify-between items-center mt-[35px] xl:mt-[50px]">
                    <motion.div
                        ref={ref}
                        initial={{ opacity: 0, clipPath: "inset(0% 50% 0% 50%)" }}
                        animate={controls}
                        className="w-full xl:w-auto"
                    >
                        <img src={m2} alt="" className="h-[115px] md:h-[249px] w-full xl:w-auto object-cover"/>
                    </motion.div>
                    <div className="mt-[20px] xl:mt-0">
                        <p className="text-[#F26522] open-sans xl:text-[20px] text-[16px]">{t('about.13')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] xl:max-w-[382px] text-[#F6F6F6]">{t('about.14')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Mission;